// This component is not currently in use since Azure hanlde login things, but is kept here for potential future use.
import style from "./AccountChangePassword.module.scss";
import AccountHeader from "./AccountHeader";
import { useState } from "react";
import { Button } from "../Button/Button";
import { validateEmail } from "../../utils/emailValidation";

const AccountChangePassword = () => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setErrorMessage("Please enter a valid email address.");
      setShowConfirmation(false);
      return;
    }

    setIsSubmitting(true);
    setErrorMessage("");
    setShowConfirmation(false);

    try {
      const response = await fetch("/api/forgotPassword", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ username: email }),
      });

      const data = await response.text();
      if (response.ok && data === "forgotpwdsuccess") {
        setShowConfirmation(true);
      } else {
        throw new Error("Request failed");
      }
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage(
        "An error occurred. Please try again later. If the problem persists, please contact support.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={style.accountContainer}>
      <AccountHeader headername="Change password" />
      <div className={style.subscriptionContainer}>
        <p>Enter your email address and we’ll send you a verification code.</p>
        <form
          name="forgotForm"
          id="forgotpwd"
          onSubmit={handleSubmit}
          className={style.form}
          autoComplete="off"
        >
          <input
            type="email"
            className={style.emailInput}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
          />

          {errorMessage && (
            <div className="alert alert-danger mt-2" role="alert">
              {errorMessage}
            </div>
          )}

          {showConfirmation && (
            <div className="alert alert-success mt-2" role="alert">
              A verification code has been sent to your email.
            </div>
          )}

          <Button
            type="submit"
            bgColor="black"
            disabled={isSubmitting}
            className={style.sendVerificationButton}
          >
            {isSubmitting ? "Submitting..." : "Send Verification Code"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AccountChangePassword;
